import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebook, FaTiktok } from "react-icons/fa";
import { motion, useAnimation, useInView } from "framer-motion";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";

const ContactPage = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Kontakti | 21 Ditë Produkt";
  }, []);
  const handleOrder = (e) => {
    e.preventDefault();

    const form = e.target;

    emailjs
      .sendForm(
        "service_7biuhua",
        "template_7w8pbxh",
        form,
        "u_41kRZzICRMIjAy6"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Mesazhi u dergua me sukses!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to place order.");
        }
      );
  };
  return (
    <Container>
      <motion.div
        ref={ref}
        className="left"
        animate={{ opacity: 1, x: 0 }}
        initial={{ opacity: 0, x: -200 }}
        transition={{
          duration: 0.7,
          bounce: 0.3,
          delay: 0.4,
          type: "spring",
        }}
      >
        <h1>
          Keni pyetje? <br /> Na kontaktoni tani
        </h1>
        <p>
          Na kontaktoni për ndihmë të personalizuar dhe informacion të detajuar.
        </p>
        <Link to={"https://www.instagram.com/21_dite_paakne/"} target="_blank">
          <RiInstagramFill className="icon insta" />
        </Link>
        <Link to={"https://www.tiktok.com/@21ditepaakne"} target="_blank">
          <FaTiktok className="icon" />
        </Link>
        <Link to={"https://www.facebook.com/21ditepaakne"} target="_blank">
          <FaFacebook className="icon" />
        </Link>
      </motion.div>
      <motion.form
        onSubmit={handleOrder}
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{
          duration: 0.7,
          delay: 0.8,
        }}
      >
        <h2>Na Kontakto</h2>
        <input type="text" name="name" placeholder="Emri i plotë" required />
        <input
          type="phone"
          name="phoneNumber"
          placeholder="Numri Kontaktues"
          required
        />
        <textarea
          cols="20"
          rows="4"
          name="message"
          placeholder="Mesazhi ose pytja"
          required
        ></textarea>
        <button type="submit">DËRGO</button>
      </motion.form>
    </Container>
  );
};
const Container = styled.div`
  color: var(--fontPrimaryColor);
  background: var(--primaryBackgroundColor);
  padding: 7em 8%;
  display: flex;
  justify-content: center;
  gap: 10px;
  font-family: "Montserrat", cursive;
  position: relative;
  .left {
    margin-top: 5%;
    width: 65%;
    z-index: 0;
    h1 {
      font-size: 5.7vw;
      line-height: 1.1em;
      font-weight: 400;
      font-family: "The Seasons", serif;
      color: #707070;
    }
    p {
      margin-right: 17%;
      color: var(--fontSecondaryColor);
      font-weight: 300;
      margin-top: 1em;
      max-width: 400px;
    }
    .icon {
      font-size: 2.5em;
      margin-top: 10px;
      margin-left: 7px;
      color: #278527c1;
    }
    .insta {
      font-size: 3.4em;
      padding-top: 10px;
    }
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 1em;
    width: 700px;
    padding: 2em;
    z-index: 1;
    h2 {
      font-weight: 300;
      text-align: center;
      margin-bottom: 10px;
    }
    input,
    textarea {
      font-family: "Montserrat", cursive;
      padding: 10px;
      font-size: 16px;
      border: none;
      border-bottom: 1px solid #8cd88cc1;
      background: none;
      outline: none;
      ::placeholder {
        color: var(--fontSecondaryColor);
      }
    }
    button {
      margin-top: 1em;
      display: flex;
      align-self: flex-start;
      margin: auto;
      padding: 17px;
      font-size: 18px;
      font-family: "Comfortaa", cursive;
      background: none;
      border: 1px solid #acacac;
      color: #575757;
      cursor: pointer;
      transition: 0.4s;
      &:hover {
        background: #278527c1;
        box-shadow: 0 0 14px 2px var(--shadowColor);
        color: white;
        border: 1px solid #278527c1;
      }
    }
  }
  @media (max-width: 1300px) {
    padding: 4em 7%;
    .left {
      h1 {
        font-size: 3em;
      }
    }
  }
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    .left {
      width: 100%;
      h1 {
        font-size: 3em;
      }
      p {
        text-align: center;
        margin: auto;
      }
    }
    form {
      width: 90%;
    }
  }
  @media (max-width: 550px) {
    padding: 6em 6% 4em 6%;
    form {
      width: 100%;
      padding: 10px;
    }
    .left {
      h1 {
        font-size: 3em;
      }
    }
  }
`;

export default ContactPage;
